export enum ReportFileType {
    Pdf = 1,
    Xls = 2
}